/**
 * Shared copy for the Excel-opening CTAs.
 *
 * These live in one place deliberately: the labels were duplicated at nine call
 * sites and drifted into six different strings, which is the drift this pill was
 * introduced to undo. Adding a tenth call site should mean importing these, not
 * retyping them.
 */
export const EXCEL_ANALYSIS_LABEL = 'Excel Analysis';
export const EXCEL_ANALYSIS_LOADING_LABEL = 'Generating…';

/** The all-directors combined workbook. */
export const COMBINED_ANALYSIS_LABEL = 'Combined Excel Analysis';
